import { render } from "./CRMWhatsappMediaCatalogMediaDialog.vue?vue&type=template&id=125cd195"
import script from "./CRMWhatsappMediaCatalogMediaDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappMediaCatalogMediaDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__